/** 프로덕션 환경 */
export const isProductionEnv =
  process.env.NODE_ENV === 'production' &&
  !window.location.host.includes('dev');
